import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IActionResource, IListResource } from '../../../../httpClient/resources/Resource';
import { ResourceQuery } from '../../../../httpClient/resources/ResourceQuery';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../../../httpClient/WebHttpClientWithErrorToast';
import { DeleteCustomizedViewsRequest } from './DeleteCustomizedViewsRequest';
import { GetCustomizedViewActionsRequest } from './GetCustomizedViewActionsRequest';
import { GetCustomizedViewsRequest } from './GetCustomizedViewsRequest';
import { ICustomViewActions } from './ICustomViewActions';
import { ICustomViewInfo } from './ICustomViewInfo';
import { SetCustomizedViewsOwnerRequest } from './SetCustomizedViewsOwnerRequest';


class CustomViewsResource implements IListResource<ICustomViewInfo>, IActionResource<ICustomViewActions> {

  private listFetcher = new WebClientListResourceFetcher(
    GetCustomizedViewsRequest,
    ServerApiMapper.customViews);

  private getErrorNotifyingServer(): WebHttpClientWithErrorToast {
    return WebHttpClientWithErrorToastInstance;
  }

  public all(): ResourceQuery<ICustomViewInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public actions(id: string): Promise<ICustomViewActions> {
    return WebHttpClient.sendRequest(new GetCustomizedViewActionsRequest(id));
  }

  public del(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteCustomizedViewsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setOwner(ids: string[], ownerId: string): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetCustomizedViewsOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }
}

export const CustomViews = new CustomViewsResource;
